import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const guiaOrientacion = {
	state: {
		guiaOrientacion: ''		
	},
	getters: {
		getGuiasOrientacion: state => state.guiaOrientacion
	},
	actions: {
		requestGuiasOrientacion: function ({ commit, dispatch }, type) {

			let url = '/api/Alumno/dameGuiaOrientacion';

			return new Promise((resolve, reject) => {
				axios.get(url).then(response => {
					(response.data.status == 0) ? commit('setGuiasOrientacion', response.data.datos) : commit('setCompleteError', response);
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});

		},
		
	},
	mutations: {
		setGuiasOrientacion: function (state, data) {
			state.guiaOrientacion = data;
		}
	}
}

export default guiaOrientacion;



// WEBPACK FOOTER //
// ./src/store/guia-orientacion.js